import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const ErpBlocksPage = lazy(() => import('./pages/ErpBlocksPage'));

export const ErpBlocksRoutes: RouteObject = {
  path: 'erp-blocks',
  children: [
    { path: '', element: <ErpBlocksPage />, handle: { crumb: 'Live ERP Data Blocks' } },
  ],
};
